import {useEffect} from 'react';

export function useMetaDescriptionCorrespondingToFields(regionNames, tiers) {
  useEffect(() => {
    addMetaTitleAndDescription(regionNames, tiers);
  }, [regionNames, tiers]);
}

function addMetaTitleAndDescription(regionNames, tiers) {
  function prettyJoin(items) {
    if (!items) return null;
    if (items.length === 1) return items.toString();
    return items.slice(0, items.length - 1).join(', ') + ' and ' + items[items.length - 1];
  }

  const serializedRegionNames = prettyJoin(regionNames);
  const serializedTiers = prettyJoin(tiers) === "Unranked" ? "" : prettyJoin(tiers);

  if (!serializedRegionNames && !serializedTiers) {
    _removeRobotsMetaTag();
    const urlParts = getCurrentUrl();

    switch (urlParts[4]) {
      case 'lol-account':
        setDescriptionTags("Buy League of Legends accounts from the world\\'s highest rated account store. 3,000+ buyers rate us at 5 stars 🌟. Free warranty on all accounts.");
        setTitleTags('Browse Accounts By Type and Region at UnrankedSmurfs');
        break;
      case 'ranked-accounts':
        setDescriptionTags("Buy Ranked League of Legends accounts from the world\\'s highest rated account store. 3,000+ buyers rate us at 5 stars 🌟. Free warranty on all accounts.");
        setTitleTags('Buy Ranked LoL Accounts | Highest Rated Account Store');
        break;
      case 'lol-smurf':
        setDescriptionTags('Buy LoL Smurf accounts from UnrankedSmurfs, the #1 rated and best reviewed LoL smurf store in the world. Instant delivery on all accounts & lifetime warranty.');
        setTitleTags('Buy LoL Smurfs | LoL Smurf Accounts For Sale | UnrankedSmurfs');
        break;
      case 'buy-skins':
        setDescriptionTags('Get rare, fun, exciting and cool skins for League of Legends champions in the UnrankedSmurfs LoL Skin Store. We stock a range of LoL skins from Black Alistar to Championship Riven and Medieval Twitch. No matter what skins you want, we have it in stock ✅✅. Rule the rift today with awesome new skins from UnrankedSmurfs!');
        setTitleTags('Buy LoL Skins | UnrankedSmurfs LoL Skin Shop');
        break;
      case 'valorant-account':
        setDescriptionTags("Get a head start in Valorant with our selection of Ranked Smurf Accounts. Skillfully curated to give you an edge, these accounts are your first step towards Valorant greatness.");
        setTitleTags('Ranked Valorant Smurf Accounts | UnrankedSmurfs');
        break;
      default:
        return null;
    }
  }

  if (!serializedRegionNames && serializedTiers) {
    _removeRobotsMetaTag();
    setTitleTags('Browse ' + serializedTiers + ' Accounts | UnrankedSmurfs.com');

    switch (serializedTiers) {
      case 'Iron':
        return setDescriptionTags('Is it the time to start your Iron to Challenge climb? Or do you want to be a tourist in elo hell? Regardless of your desire, our Iron accounts will set your heart on fire.');
      case 'Bronze':
        return setDescriptionTags('Wanna play with your low elo friends or do you prefer de-tilting by running it down mid? Our dirt-cheap Bronze accounts welcome you to their warm embrace.');
      case 'Silver':
        return setDescriptionTags('Maybe your friend is low elo and you want to help them climb, or maybe you want to hit gold without having to go through elo hell. Our affordable Silver accounts are here to serve your wish.');
      case 'Gold':
        return setDescriptionTags('Would you like to be eligible to get all the ranked rewards at the end of the season without losing your sanity trying to go through the bad low elo players? Our Gold accounts are here to help.');
      case 'Platinum':
        return setDescriptionTags('Get the bragging rights that you rightfully deserve and a beautiful banner to commemorate the occasion, along with other ranked rewards, by purchasing one of our Platinum accounts.');
      case 'Diamond':
        return setDescriptionTags('It is exhilarating to be at the top 1% of the ranked ladder and obtain all the ranked rewards with it as well. Well, fret not, our Diamond accounts assure you that experience with no effort.');
      case 'Master':
        return setDescriptionTags('Would you like to play alongside pros and streamers? Our cheap Master accounts will let you enjoy this luxury immediately.');
      case 'GrandMaster':
        return setDescriptionTags('Our Grandmaster accounts will give you the opportunity to be in the absolute top tier players that League has to offer. Not to mention insane season rewards.');
      case 'Challenger':
        return setDescriptionTags('With one of our Challenger accounts. Become one of the top 300 most skilled and famous players in League of Legends. Enjoy your unique gold recall and shine!');
      default:
        _addRobotsMetaTag();
        _addDefaultDescription();
    }
  }

  if (serializedRegionNames && !serializedTiers) {
    _removeRobotsMetaTag();
    setTitleTags('Browse ' + serializedRegionNames + ' Accounts | UnrankedSmurfs.com');

    switch (serializedRegionNames) {
      case 'EUW':
        return setDescriptionTags('Browse the best EUW hand leveled accounts on the market. See our accounts in all ranks ready for you to start your solo queue adventures! Why wait, play today.');
      case 'NA':
        return setDescriptionTags('See our top quality NA hand leveled accounts. We have hand leveled accounts of all ranks stacked with Blue Essence so you can play wherever you want right now!');
      case 'EUNE':
        return setDescriptionTags('The best accounts EUNE has to offer. 100% Hand leveled, packed with Blue Essence ready for you to start at ANY rank');
      case 'OCE':
        return setDescriptionTags('Looking for the best quality hand leveled OCE accounts available for purchase? Look no further, top quality, hand leveled and ready for ranked!');
      case 'BR':
        return setDescriptionTags('Shopping for a new BR account? We have the best hand leveled accounts in the region, covering all ranks and packed full of Blue Essence. Play today!');
      case 'LAN':
        return setDescriptionTags('Curious about how far you could climb in LAN? We have accounts of all ranks that are hand leveled with care. Packed with Blue Essence and ready for you to play!');
      case 'LAS':
        return setDescriptionTags("Look no further. We have the absolute highest quality LAS accounts on the market. From Iron to Challenger you can start your ranked climb right now. Let's go!");
      case 'RU':
        return setDescriptionTags('RU accounts are often hard to come by. We are changing that dynamic. Browse our top quality RU accounts that are all hand leveled and stocked with Blue Essence!');
      case 'TR':
        return setDescriptionTags('Eager to play ranked on the TR server? Look no further. Browse the highest quality League of Legends accounts in the region. Hand leveled at all ranks.');
      case 'JP':
        return setDescriptionTags('Outstanding hand leveled top quality accounts available for the JP server. The best League of Legends accounts in the entire region ready for ranked play!');
      default:
        _addRobotsMetaTag();
        _addDefaultDescription();
    }
  }

  if (serializedRegionNames && serializedTiers) {
    _removeRobotsMetaTag();
    setTitleTags(
      'Browse ' +
      serializedRegionNames +
      ' ' +
      serializedTiers +
      ' LoL Accounts | UnrankedSmurfs.com'
    );

    if (
      serializedRegionNames.split('+').length > 1 ||
      serializedTiers.split('+').length > 1
    ) {
      _addRobotsMetaTag();
      _addDefaultDescription();
    }

    switch (serializedRegionNames) {
      case 'EUW':
        switch (serializedTiers) {
          case 'Iron':
            return setDescriptionTags('Buy low elo ranked Iron accounts on Europe West server. Our accounts have all placements played and are ready for you to stomp noobs.');
          case 'Bronze':
            return setDescriptionTags('Europe West Bronze accounts let you start your climb almost at the bottom of the ranked ladder. Perfect for duoq with your friend or just to have fun at low elo.');
          case 'Silver':
            return setDescriptionTags('Silver Europe West accounts let you play with all low elo ranks. Play with friends instantly the account has all placement games played.');
          case 'Gold':
            return setDescriptionTags('Our Gold Europe West account guarantees you will receive your end of season rewards with 0 effort. Jump into Gold soloq instantly.');
          case 'Platinum':
            return setDescriptionTags('Our Platinum Europe West account guarantees you will receive your end of season rewards with 0 effort including the platinum chroma.');
          case 'Diamond':
            return setDescriptionTags('Our Europe West Diamond accounts puts you at the top 1% of players of the ranked ladder. Skip the 100+ games climb get it instantly after purchase.');
          case 'Master':
            return setDescriptionTags('Our Europe West Master accounts let you play on regular basis with Pros and streamers. Enjoy the high-elo instantly after your purchase.');
          case 'GrandMaster':
            return setDescriptionTags('Our Europe West Grandmaster accounts let you play at the almost absolute top of the ranked ladder. Get almost all possible ranked rewards.');
          case 'Challenger':
            return setDescriptionTags('Our EUW Challenger accounts will make you one of the top 300 highest ranked players. You will receive all exclusive ranked rewards including the gold recall.');
          default:
            return null;
        }
      case 'NA':
        switch (serializedTiers) {
          case 'Iron':
            return setDescriptionTags('Want to smurf in low elo? Our North American Iron LoL accounts are perfect for it. How fast can you climb?');
          case 'Bronze':
            return setDescriptionTags('Need a bronze account for a duo on North American server? Or maybe just want to experience low elo? Give it a try.');
          case 'Silver':
            return setDescriptionTags('An NA Silver account is ideal for a new smurf. Forget doing placements and start off right in silver. Ideal for duoing with Bronze and Gold players!');
          case 'Gold':
            return setDescriptionTags('Guaranteed Victorious Skin accounts. North American Gold accounts available right now. Get ranked rewards.');
          case 'Platinum':
            return setDescriptionTags('Platinum North American account puts you at roughly 10% of top ranked ladder players. You can get it without any effort almost instantly.');
          case 'Diamond':
            return setDescriptionTags('North American Diamond accounts with lifetime warranty. Show off to your friends and skip the climb. Road to master is ahead of you.');
          case 'Master':
            return setDescriptionTags('NA Master Accounts make you eligible for scholarships in most universities. No need to climb for that we have it ready waiting for you.');
          case 'GrandMaster':
            return setDescriptionTags('Our NA Grandmaster accounts put you at the near top of the ladder. A coveted and respected rank granting you almost all seasonal ranked rewards.');
          case 'Challenger':
            return setDescriptionTags('Our NA Challenger accounts are of peak quality. Take your place as one of the greatest players on the server and reap the fame and rewards that come with!');
          default:
            return null;
        }
      case 'EUNE':
        switch (serializedTiers) {
          case 'Iron':
            return setDescriptionTags('Need an Iron EUNE LoL Account for your low elo play montage? Are you making a climb from Iron to Challenger? We got you covered. Get yours today.');
          case 'Bronze':
            return setDescriptionTags('Play with Europe Nordic East bronze players on your brand new account. This account is perfect if you are a player from the other European server and want to duo with your friends.');
          case 'Silver':
            return setDescriptionTags('Queue up with your friends from Europe Nordic east on your new account from UnrankedSmurfs.com Lifetime warranty and instant delivery included for free.');
          case 'Gold':
            return setDescriptionTags('Impress your friends with the Europe Nordic East Gold account. Skip your end of season climb and get guaranteed rewards.');
          case 'Platinum':
            return setDescriptionTags('Join the European Nordic Eastern Platinum players with our League of Legends plat accounts. Get your dream rank today.');
          case 'Diamond':
            return setDescriptionTags('European Nordic East Diamond accounts available. High MMR boosted to rank of your choice by our professional boosters from EUNE.');
          case 'Master':
            return setDescriptionTags('Join the European Nordic Eastern exclusive 0.1% of the best players with our Master League of Legends accounts. Impress your friends and skip the climb.');
          case 'GrandMaster':
            return setDescriptionTags('Europe Nordic East Grandmaster accounts for sale. Ranked by some of the best Eastern players available at affordable price.');
          case 'Challenger':
            return setDescriptionTags('Our EUNE Challenger accounts allow you to become infamous amongst the League community. Earn full rewards such as the gold recall and reap the fame you desire!');
          default:
            return null;
        }
      case 'LAN':
        switch (serializedTiers) {
          case 'Iron':
            return setDescriptionTags('Our LAN Iron accounts will put you right at the bottom of the ladder. Complete that road to Diamond, or just stomp on noobs, your choice.');
          case 'Bronze':
            return setDescriptionTags('Perhaps you want to show off your carrying skills, or maybe you just want to have fun with friends, our LAN Bronze accounts will fulfill your every wish.');
          case 'Silver':
            return setDescriptionTags('Our LAN Silver accounts will put you one step below Gold. Will you make it out of the hell hole and claim your rewards?');
          case 'Gold':
            return setDescriptionTags('End of season rewards, High elo, and boasting rights. That is what our LAN Gold accounts will provide you with.');
          case 'Platinum':
            return setDescriptionTags('Want to brag but still look good? Our LAN Platinum accounts will give you that along with a beautiful banner that you can hone yourself with.');
          case 'Diamond':
            return setDescriptionTags('It sure feels great being in the top 1% of players by purchasing our LAN Diamond account. We guarantee a shine greater than the Star Guardians.');
          case 'Master':
            return setDescriptionTags('Ever wanted to play with the pros or with streamers? Our LAN Master accounts will give you that chance and more.');
          case 'GrandMaster':
            return setDescriptionTags('Tempted to get all the rewards League has to offer, all the while feeling like a pro? Our LAN GrandMaster accounts have you covered.');
          case 'Challenger':
            return setDescriptionTags('Be the best, or buy the best. Our LAN Challenger accounts will make you the pro you always knew you were..');
          default:
            return null;
        }
      case 'BR':
        switch (serializedTiers) {
          case 'Iron':
            return setDescriptionTags('Feeling feisty with a tad bit of desire to run it down mid? Our BR Iron accounts guarantee a premium experience of elo hell.');
          case 'Bronze':
            return setDescriptionTags('Have a friend who needs help climbing? Or maybe you just want to have fun? Our BR Bronze accounts have you covered.');
          case 'Silver':
            return setDescriptionTags('Our BR Silver accounts will put you close to Gold. Perfect for helping your hardstuck friends, or just having a rigorous grind.');
          case 'Gold':
            return setDescriptionTags('Do you just want the end of season rewards and the experience of playing with your higher elo friends? Our BR Bronze accounts are ready to serve.');
          case 'Platinum':
            return setDescriptionTags('With our BR Platinum accounts, you will have the satisfaction of having made out of Gold, all the while being praised by your friends.');
          case 'Diamond':
            return setDescriptionTags('Top 1% of the ranked ladder is calling for you. Just purchase one of our BR Diamond accounts and feel what the pros feel.');
          case 'Master':
            return setDescriptionTags('Looks like you wanna play with the pros now. Well, you’re at the right place as out BR Master accounts will provide you with that opportunity.');
          case 'GrandMaster':
            return setDescriptionTags('All the rewards that league has to offer while having a higher chance of playing with the pros. Our BR GrandMaster accounts will be sufficient for all.');
          case 'Challenger':
            return setDescriptionTags('Our BR Challenger accounts will let you go down in history as one of the servers greatest players in the region. Get your gold recall and shine amongst the many!');
          default:
            return null;
        }
      case 'RU':
        switch (serializedTiers) {
          case 'Iron':
            return setDescriptionTags('With our RU Bronze accounts, you should be able to grind hard, and occasionally run it down mid without any remorse.');
          case 'Bronze':
            return setDescriptionTags('Perhaps you’re a pro but don’t have the time to level up another account to help your friend climb. Our RU Bronze accounts have you covered.');
          case 'Silver':
            return setDescriptionTags('A rank below Gold, the ability to help your friends, all the while having fun with them. This is what our RU Silver accounts provide you with.');
          case 'Gold':
            return setDescriptionTags('You want that sweet sweet Victorious skin and be in the elo you deserve? Well, wait no more as our RU Gold account will let you do that.');
          case 'Platinum':
            return setDescriptionTags('With our RU Platinum accounts, you will become a legend amongst your low elo friends and will receive a beautiful banner to show off.');
          case 'Diamond':
            return setDescriptionTags('Do you feel that you deserve a higher elo but want to skip the climb? Our RU Diamond accounts will let you do that immediately.');
          case 'Master':
            return setDescriptionTags('We know you are talented, now go show the pros that there is a new champion in the town with our RU Master account.');
          case 'GrandMaster':
            return setDescriptionTags('Our RU Grandmaster accounts let you play at the almost absolute top of the ranked ladder. Get almost all possible ranked rewards.');
          case 'Challenger':
            return setDescriptionTags('Our RU Challenger accounts will place you in the top 300 on the server. Earn the gold recall plus all other seasonal rewards while making yourself famous!');
          default:
            return null;
        }
      case 'JP':
        switch (serializedTiers) {
          case 'Iron':
            return setDescriptionTags('Buy the cheapest Iron accounts on the Japanese server. Will you be able to climb? or will you be stuck in elo hell?');
          case 'Bronze':
            return setDescriptionTags('Our Japanese Bronze accounts will let you stomp noobs, or run it down mid without regret.');
          case 'Silver':
            return setDescriptionTags("Do you have a low elo friend who can't play well? These Japanese Silver accounts will remove that problem forever.");
          case 'Gold':
            return setDescriptionTags("Our Japanese Gold accounts will make you feel 'High Elo' and will guarantee you all the ranked rewards at the end of the season.");
          case 'Platinum':
            return setDescriptionTags('Earn some bragging rights with our Japanese Platinum Accounts. Not only will you receive all the rewards, but will also get the Platinum banner.');
          case 'Diamond':
            return setDescriptionTags('Being one of the top 1% of the players feels good, and so does putting 0 effort into getting there. Our Diamond Japanese accounts offer both.');
          case 'Master':
            return setDescriptionTags('Would you like to play alongside skilled, famous and professional players? Our Japanese Master accounts will let you enjoy this luxury immediately.');
          case 'GrandMaster':
            return setDescriptionTags('Our JP Grandmaster accounts put you at the near top of the ladder. An honorable and respected rank that comes with prestige and amazing seasonal rewards.');
          case 'Challenger':
            return setDescriptionTags('Our JP Challenger accounts provide a unique opportunity. Become one of the best players on the entire server. Flex your honorable gold recall and shine bright!');
          default:
            return null;
        }
      case 'LAS':
        switch (serializedTiers) {
          case 'Iron':
            return setDescriptionTags('Our LAS Iron accounts will let you start your adventure from bottom of the ladder. Up for a trip through elo hell?.');
          case 'Bronze':
            return setDescriptionTags('Purchase an LAS Bronze account and get the gift of being able to have fun while running it down mid without any remorse.');
          case 'Silver':
            return setDescriptionTags('Our LAS Silver accounts will put you one step below Gold. Will you give in to tilt? Or will you prove yourself and rise?');
          case 'Gold':
            return setDescriptionTags('Purchase an LAS Gold account today, and be guaranteed of the end of season rewards, as well as the feeling of being ‘High Elo.’');
          case 'Platinum':
            return setDescriptionTags('No one likes a bragger who is stuck in Gold. Purchase an LAN Platinum account and get a beautiful banner included with your rewards.');
          case 'Diamond':
            return setDescriptionTags('Tired of your climb but wanna be that ‘Knight in the Diamond armor’. Don’t worry, our LAS Diamond accounts have you covered.');
          case 'Master':
            return setDescriptionTags('This is your calling to play with the pros, so do not miss it, as our LAS Master accounts will make you feel like the king of the world.');
          case 'GrandMaster':
            return setDescriptionTags('Tempted to get all the rewards League has to offer, all the while feeling like a pro? Our LAS GrandMaster accounts have you covered.');
          case 'Challenger':
            return setDescriptionTags('Absolute top of the ladder without any effort, all the while securing the unique gold recall? The LAS Challenger accounts provide that and more.');
          default:
            return null;
        }
      case 'OCE':
        switch (serializedTiers) {
          case 'Iron':
            return setDescriptionTags('Our OCE Iron accounts will ensure that you can stomp on noobs, or just have some fun with the game. Your will to run it down mid will be sated.');
          case 'Bronze':
            return setDescriptionTags('Maybe you want to show off that you can carry hard, or maybe you just want to have fun with friends, our OCE Bronze accounts will fulfill your every wish.');
          case 'Silver':
            return setDescriptionTags('Cheap and effective, that is what we think about our OCE Silver accounts. Play with friends, or make a run for gold, your choice.');
          case 'Gold':
            return setDescriptionTags('Our OCE Gold accounts will give you the ‘High Elo’ that you always deserved and will permit you to get the end-of-season rewards.');
          case 'Platinum':
            return setDescriptionTags('Bragging rights? Our OCE Platinum accounts will give you that along with a beautiful banner that you can decorate yourself with.');
          case 'Diamond':
            return setDescriptionTags('It sure does look great being in the top 1% of players by purchasing our OCE Diamond account. We guarantee satisfaction and a lot of shine.');
          case 'Master':
            return setDescriptionTags('Playing along with streamers is impossible? Our OCE Master accounts say otherwise. Purchase one, and put that theory to test.');
          case 'GrandMaster':
            return setDescriptionTags('Our OCE GrandMaster accounts will make you feel like the king of the world and you’ll be receiving all the rewards at the end of the season. Tempted?');
          case 'Challenger':
            return setDescriptionTags('Be the best, or buy the best. Our OCE Challenger accounts will easily put you between the pros and give you the highest bragging rights.');
          default:
            return null;
        }
      case 'TR':
        switch (serializedTiers) {
          case 'Iron':
            return setDescriptionTags('Buy the cheapest Iron accounts on the Turkish server. Will you be able to climb? or will you be stuck in elo hell?');
          case 'Bronze':
            return setDescriptionTags('Perhaps you want to show off your carrying skills, or maybe you just want to have fun with friends, our Turkish Bronze accounts will fulfill your every wish.');
          case 'Silver':
            return setDescriptionTags('Our Turkish Silver accounts will put you one step below Gold. Will you give in to tilt? Or will you prove yourself and rise?');
          case 'Gold':
            return setDescriptionTags('Our Turkish Gold accounts will give you the ‘High Elo’ that you always deserved and will permit you to get the end-of-season rewards.');
          case 'Platinum':
            return setDescriptionTags('With our Turkish Platinum accounts, you will become a legend amongst your low elo friends and will receive a beautiful banner to show off..');
          case 'Diamond':
            return setDescriptionTags('The top 1% of the ranked ladder is calling for you. Just purchase one of our Turkish Diamond accounts and feel what the pros feel.');
          case 'Master':
            return setDescriptionTags('This is your calling to play with the pros, so do not miss it, as our Turkish Master accounts will make you feel like the king of the world.');
          case 'GrandMaster':
            return setDescriptionTags('Our Turkish GrandMaster accounts will make you feel like the king of the world and you’ll be receiving all the rewards at the end of the season. Tempted?');
          case 'Challenger':
            return setDescriptionTags('Be the best, or buy the best. Our Turkish Challenger accounts will make you the pro you always knew you were.');
          default:
            return null;
        }
      default:
        return null;
    }
  }
}

function _removeRobotsMetaTag() {
  if (document.querySelector('meta[name="robots"]')) {
    document.querySelector('meta[name="robots"]').remove();
  }
}

function _addRobotsMetaTag() {
  let link = document.createElement('meta');
  link.setAttribute('name', 'robots');
  link.setAttribute('content', 'noindex');
  document.getElementsByTagName('head')[0].appendChild(link);
}

function getCurrentUrl() {
  const url = new URL(window.location.href);
  return url.href.split('/');
}

function _addDefaultDescription() {
  const urlParts = getCurrentUrl();

  switch (urlParts[4]) {
    case 'lol-account':
      return setDescriptionTags("Buy League of Legends accounts from the world\\'s highest rated account store. 3,000+ buyers rate us at 5 stars 🌟. Free warranty on all accounts.");
    case 'ranked-accounts':
      return setDescriptionTags("Buy Ranked League of Legends accounts from the world\\'s highest rated account store. 3,000+ buyers rate us at 5 stars 🌟. Free warranty on all accounts.");
    case 'lol-smurf':
      return setDescriptionTags('Buy LoL Smurf accounts from UnrankedSmurfs, the #1 rated and best reviewed LoL smurf store in the world. Instant delivery on all accounts & lifetime warranty.');
    case 'buy-skins':
      return setDescriptionTags('Get rare, fun, exciting and cool skins for League of Legends champions in the UnrankedSmurfs LoL Skin Store. We stock a range of LoL skins from Black Alistar to Championship Riven and Medieval Twitch. No matter what skins you want, we have it in stock ✅✅. Rule the rift today with awesome new skins from UnrankedSmurfs!');
    default:
      return null;
  }
}

function setDescriptionTags(description) {
  document.querySelector('meta[name="description"]').content = description;
  document.querySelector('meta[name="twitter:description"]').content = description;
  document.querySelector('meta[property="og:description"]').content = description;
}

function setTitleTags(title) {
  document.title = title;
  document.querySelector('meta[name="twitter:title"]').content = title;
  document.querySelector('meta[property="og:title"]').content = title;
}
